// @flow

import {CLASS_PROPERTIES} from './constants';

import type {Column, DataTableResizeState, PropertyClasses} from './typedef';


type GetPropertyClassesType = (arg: PropertyClasses) => string;

export class DataTableResizeClass {
    id: string;
    getPropertyClasses: GetPropertyClassesType;

    constructor(id: string, getPropertyClasses: GetPropertyClassesType) {
        this.id = id;
        this.getPropertyClasses = getPropertyClasses;
    }

    getElement = (selector: string) => {
        return document.getElementById(`${this.id}${selector}`);
    };

    getTablesElements<T>(column: Column<T>, path: string) {
        const {fixed} = column;
        return Object.keys(CLASS_PROPERTIES).map<HTMLElement | null>(property => (
            this.getElement(`${this.getPropertyClasses({[property]: true, fixed})}-${path}`)
        ));
    }

    setWidth = (el: HTMLElement | null, value: string, property: string = 'width') => {
        if (!el) {
            return;
        }

        el.style.setProperty(property, value);
    };

    onResize = <T>(state: DataTableResizeState, column: Column<T>, key: number) => {
        const {fixed} = column;
        const headerTable = this.getElement(`${this.getPropertyClasses({fixed})}-header-table`);

        if (headerTable) {
            const tableWidth = parseInt(headerTable.offsetWidth);
            const deltaWidth = `${tableWidth + state.deltaX}px`;

            this.setWidth(headerTable, deltaWidth, '--table-width');

            this.getTablesElements(column, 'table').forEach(el => this.setWidth(el, deltaWidth, '--table-width'));
        }

        this.getTablesElements(column, `header-cell-${key}`).forEach(el => this.setWidth(el, `${state.width}px`));
    };

    onStartResize = <T>(column: Column<T>, key: number) => {
    };

    onStopResize = <T>(state: DataTableResizeState, column: Column<T>, key: number) => {
        const {fixed} = column;
        const headerCell = this.getElement(`${this.getPropertyClasses({fixed})}-header-${key}`);

        this.setWidth(headerCell, `${state.width}px`);
    };
}

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
